export default {
	FEED: '/racao/',
	FEEDING: '/arracoamento/',
	FEEDING_ITEM: id => `/arracoamento/${id}`
};